document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".video-product-section");
  if (!section) return;

  const slides = section.querySelectorAll(".video-slide");
  let currentIndex = 0;

  function playVideo(index) {
    slides.forEach((slide) => {
      const video = slide.querySelector("video");
      slide.classList.remove("active");
      video.pause();
      video.currentTime = 0;
    });

    const activeSlide = slides[index];
    const activeVideo = activeSlide.querySelector("video");

    activeSlide.classList.add("active");
    activeVideo.play();

    activeVideo.onended = function () {
      currentIndex = (currentIndex + 1) % slides.length;
      playVideo(currentIndex);
    };
  }

  if (slides.length > 0) {
    playVideo(0);
  }
});
